import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";

/**
 * @name CounterValue
 * @class CounterValue
 * @extends {ConnectedHTMLElement}
 */
export class CounterValue extends ConnectedHTMLElement {
  static observedAttributes = ["player"];
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    this.render();
  }

  render() {
    const player = this.getAttribute("player");
    const opponent = player === "top" ? "bottom" : "top";
    if (this.state.currentGame === undefined) {
      this.innerHTML = "";
      return;
    }

    const value =
      this.state[player] !== undefined && this.state[player].base !== undefined
        ? `${this.state[player].base.hp - this.state[player].remainingHp}`
        : `0`;

    const opponentValue =
      this.state[opponent] !== undefined &&
      this.state[opponent].base !== undefined
        ? `${this.state[opponent].base.hp - this.state[opponent].remainingHp}`
        : "0";

    this.innerHTML = `
    <div class="counter-container absolute bottom-[calc(25vh-164px)] flex flex-col items-center justify-start w-full">
      <h1 class="counter-h1 m-0 heading-font">${value}</h1>
      <div class="counter-container flex flex-row items-center justify-center w-full">
        <span class="vs">vs.</span> <span class="opponent">${opponentValue}</span>
      </div>
    </div>`;
  }
  connectedCallback() {
    this.render();
  }
}
